import { useCallback } from "react";
import { resendSignUpCode } from "aws-amplify/auth";
import { toast } from "sonner";


const useResendEmailVerificationCode = () => {
  
  const resendVerificationCode = useCallback(
    async (email: string) => {
 
      try {
    
        await resendSignUpCode({ username: email});
        toast.success("Verification code successfully sent");
        return true;
      } catch (error: any) {
        if (error?.name === "LimitExceededException") {
          toast.error("Too many requests. Please try again later.");
        } else if (error?.name === "UserNotFoundException") {
          toast.error("User not found. Please check your email.");
        } else {
          toast.error("An error occurred while resending the verification code.");
        }
        console.error("Error resending verification code:", error);
        return false;
      }
    },
    []
  );

  return {
    resendVerificationCode,
  };
};

export default useResendEmailVerificationCode;
